import React from "react";
import { BsArrowRightShort } from "react-icons/bs";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import CustomViewButton from "../../../CustomComponent/custom_view_button";

const tableHead = [
  "Sr.",
  "Society Name",
  "Society Contact Number",
  "Society Address",
  "Num Of Peoples",
  "Actions",
];

function SocietyOnboardingtable({ data = [], currentPage, itemsPerPage }) {
  const navigate = useNavigate();
//   const store = useSelector((store) => store.login.user);
  const goToView = (id) => {
    navigate(`/view-society-onboardings/${id}`);
  };

  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead?.map((item, index) => {
              return <th key={index}>{item}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {data?.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <tr key={item?.id}>
                <td>{Index}</td>
                <td>{item?.societyName || "N/A"}</td>
                <td>{item?.phone || "N/A"}</td>
                <td>{item?.addressLine1 || item?.addressLine2 || "N/A"}</td>
                <td>{item?.numofPeopleSize || "N/A"}</td>
                <td>
                  <CustomViewButton
                    onClick={() => goToView(item?.id)}
                  ></CustomViewButton>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default SocietyOnboardingtable;
